import { HttpInterceptorFn } from '@angular/common/http';

/**
 * vwappservices builds every request URL as `location.origin + url` when the app is not on localhost, with no "/" in
 * between, while this app passes paths like 'user/getfinancialyears'. On a deployed site that produced
 * https://host + user/getfinancialyears = https://hostuser/getfinancialyears (request fails, no financial years on the
 * login screen). This puts the missing slash back, in one place, for every call. Localhost builds use config.baseUrl
 * (which already ends with "/") and are left untouched.
 */
export const originSlashInterceptor: HttpInterceptorFn = (req, next) => {
  const origin = location.origin;
  if (!origin.includes('localhost') && req.url.startsWith(origin)) {
    const rest = req.url.slice(origin.length);
    if (/^[A-Za-z0-9_-]+\//.test(rest)) req = req.clone({ url: `${origin}/${rest}` });
  }
  return next(req);
};
